<template>
  <div>
    <v-card>
      <v-card-title>
        Nuevo Producto
        <v-spacer></v-spacer>
        <v-btn class="ma-2" color="red" fab small dark @click="_cerrar()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <form>
          <v-text-field
            counter
            label="Codigo"
            required
            v-model="producto.codigo"
            :error-messages="errorCodigo"
            @input="$v.producto.codigo.$touch()"
            @blur="$v.producto.codigo.$touch()"
          ></v-text-field>
          <v-text-field
            counter
            label="Nombre"
            required
            v-model="producto.nombre"
            :error-messages="errorNombre"
            @input="$v.producto.nombre.$touch()"
            @blur="$v.producto.nombre.$touch()"
          ></v-text-field>
          <v-text-field
            counter
            type="number"
            label="Precio"
            required
            v-model="producto.precio"
          ></v-text-field>
          <v-btn
            class="ma-2"
            block
            :color="$v.producto.$invalid ? 'error' : 'success'"
            @click="guardarProducto()"
          >
            <v-icon left>
              {{ $v.producto.$invalid ? "mdi-close" : "mdi-check" }} </v-icon
            >Guardar Producto
          </v-btn>
        </form>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
const greaterThanZero = (value) => value > 0;
export default {
  name: "Productos_Nuevo",
  data() {
    return {
      producto: {
        codigo: "",
        nombre: "",
        precio: 0,
      },
    };
  },
  created() {
    if(this.$route.params.producto) {
      let producto = this.$route.params.producto
      if(producto.nombre) this.producto.nombre = producto.nombre
    }
  },
  methods: {
    async guardarProducto() {
      this.$v.producto.$touch();
      if (!this.$v.producto.$invalid) {
        try {
          if (this.foto != "") this.producto.foto = this.foto;
          const producto = await axios.post("/producto/nuevo", this.producto);
          let id = producto.data;
          if(this.$route.params.volver) {
            this.$router.push({
              name: this.$route.params.volver.url,
              params: {
                datos: this.$route.params.volver.datos,
                producto: {
                  _id: id,
                  nombre: this.producto.nombre,
                  costo: 0
                }
              }
            })
          } else {
            this.$router.push(`/productos/${id}`);
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    _cerrar() {
      this.$router.go(-1);
    },
  },
  validations: {
    producto: {
      codigo: { required, minLength: minLength(3) },
      nombre: { required, minLength: minLength(3) },
    },
  },
  computed: {
    errorNombre() {
      const errors = [];
      if (!this.$v.producto.nombre.$dirty) return errors;
      !this.$v.producto.nombre.minLength &&
        errors.push("El Nombre debe tener al menos 3 caracteres.");
      !this.$v.producto.nombre.required &&
        errors.push("Debe ingresar un Nombre.");
      return errors;
    },
    errorCodigo() {
      const errors = [];
      if (!this.$v.producto.codigo.$dirty) return errors;
      !this.$v.producto.codigo.minLength &&
        errors.push("El Codigo debe tener al menos 3 caracteres.");
      !this.$v.producto.codigo.required &&
        errors.push("Debe ingresar un Codigo.");
      return errors;
    },
  },
};
</script>
